import { WizardLayout } from '../../components/wizard/WizardLayout';
import { WizardStep } from '../../components/wizard/WizardStep';
import { de } from '../../lib/i18n/de';
import { useDimensionForm } from '../../components/wizard/fields/useDimensionForm';
import {
  BooleanField,
  NumberField,
  TextareaField,
} from '../../components/wizard/fields/FormFields';
import { STYLE_KEYS, parseList, serializeList } from '../../lib/store/dimensionScoreInput';
import { DimensionLiveScore } from '../../components/wizard/fields/DimensionLiveScore';

const t = de.dimensionFields.style;

export function StyleStep() {
  const form = useDimensionForm('style');
  const hasContent = Object.values(form.fields).some((v) => v.trim().length > 0);
  // Wettbewerber: pro Zeile ein Eintrag; als String-Liste serialisiert.
  const competitorsText = parseList<string>(form.get(STYLE_KEYS.competitors)).join('\n');

  return (
    <WizardLayout>
      <WizardStep
        stepId="style"
        canProceed={hasContent}
        lastSavedAt={form.lastSavedAt}
        saveState={form.lastSavedAt ? 'saved' : 'idle'}
        onProceed={form.markComplete}
      >
        <div className="space-y-8">
          <BooleanField
            id="style-target-defined"
            label={t.targetGroupDefinedLabel}
            required
            value={form.get(STYLE_KEYS.targetGroupDefined)}
            onChange={(v) => {
              form.set(STYLE_KEYS.targetGroupDefined, v);
            }}
          />
          <TextareaField
            id="style-target-desc"
            label={t.targetGroupDescriptionLabel}
            hint={t.targetGroupDescriptionHint}
            helpKey="style.positioning"
            minLength={30}
            value={form.get(STYLE_KEYS.targetGroupDescription)}
            onChange={(v) => {
              form.set(STYLE_KEYS.targetGroupDescription, v);
            }}
          />
          <TextareaField
            id="style-competitors"
            label={t.competitorsLabel}
            hint={t.competitorsHint}
            placeholder={t.competitorsPlaceholder}
            rows={4}
            value={competitorsText}
            onChange={(v) => {
              form.set(STYLE_KEYS.competitors, serializeList(v.split('\n')));
            }}
          />
          <TextareaField
            id="style-differentiators"
            label={t.differentiatorsLabel}
            hint={t.differentiatorsHint}
            minLength={30}
            value={form.get(STYLE_KEYS.differentiators)}
            onChange={(v) => {
              form.set(STYLE_KEYS.differentiators, v);
            }}
          />
          <NumberField
            id="style-self-rate"
            label={t.selfRateLabel}
            suffix={t.selfRateSuffix}
            min={0}
            value={form.get(STYLE_KEYS.selfReportedHourlyRateEuro)}
            onChange={(v) => {
              form.set(STYLE_KEYS.selfReportedHourlyRateEuro, v);
            }}
          />
          <NumberField
            id="style-floor-rate"
            label={t.floorRateLabel}
            hint={t.floorRateHint}
            suffix={t.floorRateSuffix}
            min={0}
            value={form.get(STYLE_KEYS.industryFloorHourlyRateEuro)}
            onChange={(v) => {
              form.set(STYLE_KEYS.industryFloorHourlyRateEuro, v);
            }}
          />
          <BooleanField
            id="style-pricing-documented"
            label={t.pricingStrategyDocumentedLabel}
            required
            value={form.get(STYLE_KEYS.pricingStrategyDocumented)}
            onChange={(v) => {
              form.set(STYLE_KEYS.pricingStrategyDocumented, v);
            }}
          />
          <TextareaField
            id="style-notes"
            label={de.dimensionFields.common.notesLabel}
            hint={de.dimensionFields.common.notesHint}
            placeholder={de.dimensionFields.common.notesPlaceholder}
            rows={3}
            value={form.get(STYLE_KEYS.notes)}
            onChange={(v) => {
              form.set(STYLE_KEYS.notes, v);
            }}
          />
          <DimensionLiveScore dimension="style" fields={form.fields} />
        </div>
      </WizardStep>
    </WizardLayout>
  );
}
